const emojis = ["😍", "❤️", "🔥", "😋", "😻", "😘", "🎉", "🎊"];

export function getRandomPositiveEmoji() {
  return emojis[Math.floor(Math.random() * emojis.length)];
}

export default emojis;
